import { stableCoins } from '@/components/explore/stableCoins';
import useMultiTokenData from './useMultiTokenData';
export default function useGetStableCoinData() {
    var stableCoinTokens = function () {
        return stableCoins
            .map(function (stableCoin) {
            var tokens = stableCoin.tokens;
            return Object.keys(tokens).map(function (chainId) {
                return tokens[chainId] + ':' + chainId;
            });
        })
            .flat();
    };
    return useMultiTokenData({ tokens: stableCoinTokens() });
}
